export * from './jsonata/jsonata-object.class';
